// =============================================================================
// IMPRESSUM — Rechtliche Pflichtangaben nach §5 TMG
// -----------------------------------------------------------------------------
// Daten kommen aus config.js (IMPRESSUM-Objekt). Layout-Klassen sind in App.css
// unter "LEGAL PAGES" definiert.
// =============================================================================

import { Link } from "react-router-dom";
import { BackIcon } from "@/icons";
import { IMPRESSUM } from "@/config";
import Background from "@/components/Background";

export default function Impressum() {
  return (
    <div data-testid="impressum-page">
      <Background />

      <main className="legal-page">
        <Link to="/" className="legal-back" data-testid="impressum-back">
          <BackIcon size={14} aria-hidden="true" /> Zurück
        </Link>

        <h1 className="legal-title">Impressum</h1>

        <section className="legal-block">
          <h2>Angaben gemäß § 5 TMG</h2>
          <p>
            {IMPRESSUM.name}<br />
            {IMPRESSUM.street}<br />
            {IMPRESSUM.city}<br />
            {IMPRESSUM.country}
          </p>
        </section>

        <section className="legal-block">
          <h2>Kontakt</h2>
          <p>
            E-Mail:{" "}
            <a href={`mailto:${IMPRESSUM.contactEmail}`}>
              {IMPRESSUM.contactEmail}
            </a>
          </p>
        </section>

        <section className="legal-block">
          <h2>Hinweis</h2>
          <p>
            Diese Website wird privat und nicht-kommerziell als Hobbyprojekt
            betrieben. Es werden über diese Seite keine entgeltlichen Leistungen
            angeboten.
          </p>
        </section>

        <section className="legal-block">
          <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
          <p>
            {IMPRESSUM.name}<br />
            {IMPRESSUM.street}<br />
            {IMPRESSUM.city}
          </p>
        </section>

        <section className="legal-block">
          <h2>Haftung für Inhalte</h2>
          <p>
            Als Diensteanbieter bin ich gemäß § 7 Abs. 1 TMG für eigene Inhalte
            auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
            §§ 8 bis 10 TMG bin ich als Diensteanbieter jedoch nicht
            verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
            überwachen oder nach Umständen zu forschen, die auf eine
            rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung
            oder Sperrung der Nutzung von Informationen nach den allgemeinen
            Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist
            jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
            Rechtsverletzung möglich. Bei Bekanntwerden entsprechender
            Rechtsverletzungen werde ich diese Inhalte umgehend entfernen.
          </p>
        </section>

        <section className="legal-block">
          <h2>Haftung für Links</h2>
          <p>
            Mein Angebot enthält Links zu externen Websites Dritter, auf deren
            Inhalte ich keinen Einfluss habe. Deshalb kann ich für diese fremden
            Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
            verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
            der Seiten verantwortlich. Die verlinkten Seiten wurden zum
            Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
            Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht
            erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten
            Seiten ist jedoch ohne konkrete Anhaltspunkte einer
            Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
            Rechtsverletzungen werde ich derartige Links umgehend entfernen.
          </p>
        </section>

        <section className="legal-block">
          <h2>Urheberrecht</h2>
          <p>
            Die durch den Seitenbetreiber erstellten Inhalte und Werke auf
            diesen Seiten unterliegen dem deutschen Urheberrecht. Die
            Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
            Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
            schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            Downloads und Kopien dieser Seite sind nur für den privaten, nicht
            kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser
            Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte
            Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
            gekennzeichnet. Sollten Sie trotzdem auf eine
            Urheberrechtsverletzung aufmerksam werden, bitte ich um einen
            entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
            werde ich derartige Inhalte umgehend entfernen.
          </p>
        </section>

        <Link
          to="/"
          className="legal-back legal-back-bottom"
          data-testid="impressum-back-bottom"
        >
          <BackIcon size={14} aria-hidden="true" /> Zurück zur Startseite
        </Link>
      </main>
    </div>
  );
}
